import type { PieChartData } from '~/domain/dashboard/models/pie-chart-model.';

export enum AppGatewaysStatus {
  ONLINE = 'online',
  OFFLINE = 'offline',
  NEEDS_ATTENTION = 'needs_attention',
}

export type AppGatewaysStatusCategory = {
  numberOfMachines: number;
  translationKey: string;
  state: AppGatewaysStatus;
};

export type AppGatewaysResponse = {
  gatewayStatuses: AppGatewaysStatusCategory[];
  totalNumberOfMachines: number;
};

export type AppGatewaysWidgetData = {
  chartData: PieChartData[];
  totalNumberOfMachines: number;
};
